<template lang="pug">
  .grid-scattered.md-w-xl.mx-auto(:class="{'flip': r[0]}")
    //- row
    .md-w-grid-20.md--ml-20.px-15.md-px-10.pointer-events-none(v-for="(item, i) in items")
      //- row height, overlap
      .relative.md-pb-50pct(:class="{'mt-100 md--mt-25pct': i > 0, 'border': debug}", :style="{borderColor: debug && 'currentColor', color: debug && i % 4 === 0 ? 'red' : debug && i % 4 === 1 ? 'blue' : debug && i % 4 === 3 ? 'green' : debug ? 'orange' : ''}")
        //- column (via justify)
        .md-absolute.inset-0.flex.items-stretch(:class="{'justify-start': i % 3 === 0, 'justify-center': i % 3 === 1, 'justify-end': i % 3 === 2}")
          //- cell body
          article.w-2x3.md-w-1x3.md-px-10.flex(:class="[align(i), {'flip': r[0]}]")

            //- (wps_collection item)
            template(v-if="item.type === 'wps_collections'")
              products-collection-thumb.w-full.md-w-10x12.pointer-events-auto(:rt="{name: 'products_collection', params: { collection: item.post.post_name}}", :image="item.image", :class="{'border border-black': debug}") {{item.post.post_title}}

            //- (blue-project item)
            template(v-else)
              router-link.block.w-full.md-w-3x4.pointer-events-auto(:to="{name: 'blue-project', params: { slug: item.post.slug }}", :class="{'border border-white': debug}")
                figure(v-if="item.image", :class="{'border border-black': debug}")
                  .relative
                    resp-img(:src="item.image.src", :alt="item.image.alt", imgClass="max-h-66vw md-max-h-20vw")
                header.mt-30.md-mt-60
                  h4.text-17 {{debug ? i+1 : ''}} {{item.post.acf.title_main}}
                  h4.text-17.italic(v-if="item.post.acf.title_sub") {{item.post.acf.title_sub}}
                  h6.text-13.mt-2 {{item.post.acf.date_opening}} &ndash; {{item.post.acf.date_closing}}
</template>

<script>
import ProductsCollectionThumb from '@/components/Shop/ProductsCollectionThumb'
const bool = () => Math.round(Math.random())
export default {
  name: 'GridScattered',
  props: {
    items: { type: Array, default: () => ([]) }
  },
  data () {
    return {
      debug: this.$route.query.debug === 'true',
      r: [bool(), bool(), bool()]
    }
  },
  methods: {
    align (i) {
      // const n = i + 1
      return [
        // align object top/bottom ?
        // * always first item top (!i), otherwise random
        // * FORMERLY: !i || (this.r[0] + n) % 2
        i === 0 || bool() ? 'items-start' : 'items-end',
        // justify object left/right ?
        // * FORMERLY: this.r[1] && (n % 2 || this.r[2]) && 'justify-end'
        bool() && 'justify-end',
        // debug
        this.debug && 'bg-gray-200'
      ]
    }
  },
  components: { ProductsCollectionThumb }
}
</script>

<style>
</style>
